import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';
export interface IChangePasswordMeta {
  login: FormInputMeta,
  oldPassword: FormInputMeta,
  newPassword: FormInputMeta,
  typePasswordAgain: FormInputMeta,
  schema: any,
}

const ChangePasswordMeta: IChangePasswordMeta = {} as IChangePasswordMeta;

ChangePasswordMeta.login = {
  label: 'Login',
  name: 'login',
  type: 'text',
  disabled: true,
  value: 'Aubin KENGNE',
};

ChangePasswordMeta.oldPassword = {
  label: 'Ancien mot de passe',
  name: 'oldPassword',
  type: 'password',
  placeholder: 'Ancien mot de passe',
  validation: yup.string().required("Champ obligatoire !"),
};

ChangePasswordMeta.newPassword = {
  label: 'Nouveau mot de passe',
  name: 'newPassword',
  type: 'password',
  placeholder: 'Nouveau mot de passe',
  validation: yup.string().required("Champ obligatoire !"),
};

ChangePasswordMeta.typePasswordAgain = {
  label: 'Retapez le mot de passe',
  name: 'typePasswordAgain',
  type: 'password',
  placeholder: 'Retapez le mot de passe',
  validation: yup.string().required("Champ obligatoire !"),
};

const validationSchema = getValidationSchema(ChangePasswordMeta);
ChangePasswordMeta.schema = yup.object().shape(validationSchema);

export default ChangePasswordMeta;